// extracted by mini-css-extract-plugin
module.exports = {"shippingDetailsSection":"DeliveryPageContent_shippingDetailsSection__xUCPI","errorBanner":"DeliveryPageContent_errorBanner__6ki_o"};